<template>
	<div class="page" :style="[pageDiv]">
		<Tip :tip="tip" />
		<div class="from_div" :style="[fromDiv]">
			<el-form ref="form" :model="form" :rules="rules" label-position="left" label-width="110px">
				<el-form-item label="卡券信息：" style="margin-bottom: 0px;">
					<div style="display: flex;flex-direction: column;">
						<span class="span">{{cardInfo.card_name}}</span>
						<span class="span_">类型：{{cardInfo.card_type_text}} 面额：{{cardInfo.card_money}}元
							创卡：{{cardInfo.dispatch_num}}张</span>
					</div>
				</el-form-item>
				<el-form-item label="材质选择：" prop="apply_material" style="margin-bottom: 10px;">
					<el-radio-group v-model="form.apply_material">
						<el-radio :label="1">PVC卡(90-45mm)</el-radio>
						<el-radio :label="2">纸质(90-45mm 200克纸厚)</el-radio>
						<el-radio :label="3">纸质(180-45mm 200克纸厚)</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="制作数量：" prop="apply_quatity">
					<el-input class="input" v-model="form.apply_quatity" placeholder="请输入内容"></el-input>
					<span class="span_">张（不可超过创卡数量）</span>
				</el-form-item>
				<el-form-item label="封面图案：" prop="apply_coverimg">
					<el-radio-group v-model="form.apply_cover_style">
						<div class="row">
							<div v-for="(citem, cindex) in coverimgs" :key="cindex" class="col">
								<div class="upload_div">
									<img :src="citem.url" class="img">
								</div>
								<el-radio :label="cindex">{{citem.title}}</el-radio>
							</div>
							<div class="col">
								<multiUpload :type='0' :limitImg='1' :noneBtnImg='coverImgList.length > 0'
									:fileList="coverImgList" @saveImg="saveImg" @delImg="delImg" />
								<el-radio :label="-1">自定义上传</el-radio>
							</div>
						</div>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="封底图案：" prop="apply_backimg">
					<el-radio-group v-model="form.apply_back_style">
						<div class="row">
							<div v-for="(citem, cindex) in backimgs" :key="cindex" class="col">
								<div class="upload_div">
									<img :src="citem.url" class="img">
								</div>
								<el-radio :label="cindex">{{citem.title}}</el-radio>
							</div>
							<div class="col">
								<multiUpload :type='1' :limitImg='1' :noneBtnImg='backImgList.length > 0'
									:fileList="backImgList" @saveImg="saveImg" @delImg="delImg" />
								<el-radio :label="-1">自定义上传</el-radio>
							</div>
						</div>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="自定义LOGO：" prop="apply_logo" style="margin-bottom: -10px">
					<div class="row">
						<multiUpload :type='2' :limitImg='1' :noneBtnImg='logoList.length > 0'
							:fileList="logoList" @saveImg="saveImg" @delImg="delImg" />
						<span class="span_">选填（分辨率不低于300）</span>
					</div>
				</el-form-item>
				<el-form-item label="收货信息：" prop="receive_name" style="margin-bottom: 10px">
					<el-input class="input" v-model="form.receive_name" placeholder="姓名"></el-input>
					<el-input class="input" v-model="form.receive_phone" placeholder="电话"></el-input>
					<el-input class="input" v-model="form.receive_address" placeholder="省市区县街道地址"></el-input>
				</el-form-item>
				<el-form-item label="预计工期：" style="margin-bottom: 0">
					<span class="span_">10天</span>
				</el-form-item>
				<el-form-item label="物流运费：" style="margin-bottom: 0">
					<span class="span_">30天</span>
				</el-form-item>
				<el-form-item label="合计金额：" style="margin-bottom: 0">
					<div class="row">
						<span class="span_">330天</span>
						<span class="span_" style="color: #EA0000;">（提示：提交申请后，请联系客服，确认并付款，再进行实卡制作）</span>
					</div>
				</el-form-item>
			</el-form>
		</div>
		<div class="foot_div" :style="[footDiv]">
			<el-button @click="close">返回</el-button>
			<el-button type="primary" @click="submit('form')">确定</el-button>
		</div>
	</div>
</template>

<script>
	import Tip from "../../../components/Tip/Tip.vue"
	import multiUpload from "../../../components/multiUpload/multiUpload.vue"
	import {
		cardEdit,
		cardDetail,
		cardOptions
	} from "../../../request/apis.js"
	export default {
		components: {
			Tip,
			multiUpload
		},
		props: {
			type: {
				type: Number
			},
			arr: {
				type: Array
			}
		},
		data() {
			return {
				tip: '向礼品云SAAS平台申请代为制作实体卡券，带二维码，支持商城扫码绑定及消费。',
				coverImgList:[],//自定义封面
				backImgList:[],//自定义封底
				logoList:[],//自定义logo
				cardInfo: {},
				form: {
					card_id: 0,
					apply_id: '',
					apply_material: 1,
					apply_quatity: '',
					apply_cover_style: -1,
					apply_coverimg: '',
					apply_back_style: -1,
					apply_backimg: '',
					apply_logo: '',
					receive_name: '',
					receive_phone: '',
					receive_address: '',
				},
				rules: {

				},
				coverimgs: [],
				backimgs: [],
			}
		},
		computed: {
			pageDiv() {
				return {
					'position': this.type != -1 ? 'relative' : ''
				}
			},
			fromDiv() {
				return {
					'overflow': this.type != -1 ? 'scroll' : '',
					'height': this.type != -1 ? '620px' : '',
					'min-height': this.type != -1 ? '100%' : '',
					'padding-bottom': this.type != -1 ? '66px' : '',
				}
			},
			footDiv() {
				return {
					'margin-left': this.type == -1 ? '' : ''
				}
			},
		},
		mounted() {
			if (this.arr && this.arr[0]) {
				this.cardInfo = this.arr[0];
				this.form.card_id = this.cardInfo.card_id;
			}
			this.getCardOptions();
			if (this.type) {
				this.form.apply_id = this.type;
				this.getCardDetail(this.form.apply_id);
			}
		},
		methods: {
			getCardOptions() {
				cardOptions().then(res => {
					if (res.code == 0) {
						this.coverimgs = res.data.coverimgs;
						this.backimgs = res.data.backimgs;
					}
				}).catch(err => {})
			},

			getCardDetail(apply_id) {
				cardDetail({
					apply_id
				}).then(res => {
					if (res.code == 0) {
						//自定义封面
						if(res.data.apply_coverimg != ''){
							if(res.data.apply_cover_style == -1){
								this.coverImgList.push({
									url: res.data.apply_coverimg
								})
							}
						}
						//自定义封底
						if(res.data.apply_backimg != ''){
							if(res.data.apply_back_style == -1){
								this.backImgList.push({
									url: res.data.apply_backimg
								})
							}
						}
						//自定义logo
						if(res.data.apply_logo != ''){
							this.logoList.push({
								url: res.data.apply_logo
							})
						}
						this.cardInfo = res.data.card;
						this.form = res.data;
					}
				}).catch(err => {})
			},
			
			//图片存储
			saveImg(arr){
				switch (arr[1]) {
					case 0:
						//封面图
						this.form.apply_coverimg = arr[0];
						break;
					case 1:
						//封底图
						this.form.apply_backimg = arr[0];
						break;
					case 2:
						//LOGO
						this.form.apply_logo = arr[0]
						break;
				}
			},
			
			//图片移除
			delImg(arr){
				switch (arr[1]) {
					case 0:
						//封面图
						this.form.apply_coverimg = '';
						this.coverImgList = []
						break;
					case 1:
						//封底图
						this.form.apply_backimg = '';
						this.backImgList = []
						break;
					case 2:
						//LOGO
						this.form.apply_logo = ''
						this.logoList = []
						break;
				}
			},

			//提交表单
			submit(form) {
				// 不是自定义上传时获取封面图案
				if (this.form.apply_cover_style >= 0) {
					this.form.apply_coverimg = this.coverimgs[this.form.apply_cover_style].url;
				}
				// 不是自定义上传时获取内页底图
				if (this.form.apply_back_style >= 0) {
					this.form.apply_backimg = this.backimgs[this.form.apply_back_style].url;
				}
				this.$refs[form].validate((valid) => {
					if (valid) {
						cardEdit(this.form).then(res => {
							if (res.code == 0) {
								this.$message({
									type: 'success',
									message: res.msg || '操作成功!'
								});
								this.$emit('close', 0)
							} else {
								this.$message({
									type: 'error',
									message: res.msg || '操作失败!'
								});
							}
						}).catch(err => {})
					} else {
						return false;
					}
				});
			},
			close() {
				this.$emit('close')
			}
		}
	}
</script>

<style scoped>
	.page {
		margin-bottom: 66px;
		min-height: -webkit-fill-available;
	}

	.from_div {
		margin-top: 20px;
		width: 100%;
	}

	.input {
		width: 200px;
		margin-right: 20px;
	}

	.row {
		display: flex;
		flex-direction: row;
	}

	.col {
		display: flex;
		flex-direction: column;
		align-items: center;
		margin-right: 10px;
	}

	.span {
		font-size: 14px;
		color: var(--theme-color);
	}

	.span_ {
		font-size: 14px;
		color: #606266;
	}

	.img {
		width: 150px;
		height: 150px;
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
	}

	.upload_div {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: 150px;
		height: 150px;
		margin-bottom: 20px;
		background-color: #fbfdff;
		border: 1px dashed #c0ccda;
		border-radius: 6px;
	}

	.upload_div_ {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: 60px;
		height: 60px;
		margin-bottom: 10px;
		background-color: #fbfdff;
		border: 1px dashed #c0ccda;
		border-radius: 6px;
		margin-right: 20px;
	}

	.el-icon-plus {
		font-size: 20px;
		font-weight: bolder;
		color: #606266;
	}

	.foot_div {
		position: absolute;
		bottom: 0;
		left: 0;
		width: calc(100% - 120px);
		padding: 0 60px;
		line-height: 66px;
		height: 66px;
		background: #fff;
		box-shadow: 0px -4px 10px -5px rgba(0, 0, 0, 0.3);
		border-radius: 0 0 10px 10px;
	}
</style>